<div class="row mb-4">
  @if (facade.multiSavingsPlanIsStrategy$ | async) {
    <div class="col-12 mb-4">{{ 'savings-plan.add-savings-plan.strategy.hint' | transloco }}</div>
    <div
      class="col-12 mb-5 mb-md-0"
      [ngClass]="{
        'col-md-4': facade.hasMultipleIntervals$ | async,
        'col-md-6': (facade.hasMultipleIntervals$ | async) === false,
      }"
    >
      <div class="input-group-material keepcolor">
        <input
          data-zid="total-amount-strategie"
          id="totalAmount"
          type="text"
          autocomplete="off"
          inputmode="numeric"
          class="form-control"
          [value]="facade.multiSavingsPlanTotalAmount$ | async | ignoreThousandSeparator"
          (keyup)="handleChangeSum($event)"
        />
        <label for="totalAmount">
          {{ 'savings-plan.add-savings-plan.strategy.label' | transloco }}
        </label>
      </div>
    </div>
  }
  <div
    class="col-6"
    [ngClass]="{
      'col-md-4': facade.multiSavingsPlanIsStrategy$ | async,
      'col-md-6': (facade.hasMultipleIntervals$ | async) === false,
      'col-md-12':
        ((facade.multiSavingsPlanIsStrategy$ | async) === undefined || (facade.multiSavingsPlanIsStrategy$ | async) === false) &&
        (facade.hasMultipleIntervals$ | async) === false,
    }"
  >
    <div class="input-group-material select-dropdown">
      <select id="execDates" #execDates (change)="facade.changeExecDate(execDates.value)">
        <option [value]="null" disabled>
          {{ 'savings-plan.savings-plan-form.firstExecDate-placeholder' | transloco }}
        </option>
        @for (execDate of facade.execDates$ | async; track $index) {
          <option [value]="execDate" [selected]="execDate === (facade.execDate$ | async)">
            {{ execDate | date: 'shortDate' : 'UTC +2' }}
          </option>
        }
      </select>
      <label for="execDates">
        {{ 'savings-plan.savings-plan-form.firstExecDate-label' | transloco }}
      </label>
    </div>
  </div>
  @if (facade.hasMultipleIntervals$ | async) {
    <div [class]="(facade.multiSavingsPlanIsStrategy$ | async) ? 'col-6 col-md-4' : 'col-6'">
      <div class="input-group-material select-dropdown">
        <select id="intervals" data-zid="savingsplan-interval" #intervals (change)="facade.changeInterval(intervals.value)">
          <option [value]="null" disabled>
            {{ 'savings-plan.savings-plan-form.interval-placeholder' | transloco }}
          </option>
          @for (interval of facade.intervals$ | async; track $index) {
            <option [value]="interval" [selected]="interval === (facade.interval$ | async)">
              {{ 'savings-plan.savings-plan-form.interval.' + interval | transloco }}
            </option>
          }
        </select>
        <label for="intervals">
          {{ 'savings-plan.savings-plan-form.interval-label' | transloco }}
        </label>
      </div>
    </div>
  }
</div>
<saving-plans-dynamization />
